// Synexis: preenche os campos de um <submitter-item> a partir de um contato/signatário
// (name, email, phone, cpf, empresa). Fonte ÚNICA reusada pelo autocomplete embutido
// (<submitters-autocomplete>) e pelo modal "Selecionar dos contatos" (<contacts-picker>).
export default function populateSubmitterItem (submitterItemEl, item) {
  if (!submitterItemEl) return

  const fields = ['email', 'name', 'phone', 'cpf', 'empresa']

  fields.forEach((field) => {
    const input = submitterItemEl.querySelector(`submitters-autocomplete[data-field="${field}"] input`)
    const textarea = submitterItemEl.querySelector(`submitters-autocomplete[data-field="${field}"] textarea`)

    if (input && item[field]) {
      input.value = item[field]
      input.dispatchEvent(new CustomEvent('linked-input.update', { bubbles: true }))
    }

    if (textarea && item[field]) {
      // Substitui o último token parcial digitado; se não houver (campo vazio ou terminado em
      // separador), anexa — senão o `replace` seria um no-op e nada seria inserido.
      textarea.value = /[^;,\s]+$/.test(textarea.value)
        ? textarea.value.replace(/[^;,\s]+$/, item[field] + ' ')
        : textarea.value + item[field] + ' '

      textarea.dispatchEvent(new Event('input', { bubbles: true }))
    }
  })
}
